import React from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "../context/TranslationContext";
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from "react-router-dom";

import Button from '../components/Button';

function Home() {
  const { switchLanguage } = useTranslation();
  const { isDarkMode, toggleTheme } = useTheme();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const performLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div>
      <Link to="/profile">
        <button>{"Profile"}</button>
      </Link>

      <Link to="/login">
        <button>{"Login"}</button>
      </Link>

      <button onClick={() => switchLanguage("pl")}>Polski</button>
      <button onClick={() => switchLanguage("en")}>English</button>
      <button onClick={() => switchLanguage("de")}>Deutsch</button>
      <button onClick={() => switchLanguage("es")}>Espanol</button>

      <h1>{isDarkMode ? 'Dark Mode' : 'Light Mode'}</h1>
      <button onClick={toggleTheme}>
        Przełącz na {isDarkMode ? 'Light' : 'Dark'}
      </button>
  
      <button onClick={() => performLogout()}>Logout</button>
    </div>
  );
}

export default Home;